// ==============================|| THEME 1 COLORS ||============================== //

const theme1 = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#eceff1',
  primaryMain: '#607d8b',
  primaryDark: '#546e7a',
  primary200: '#b0bec5',
  primary800: '#455a64',

  // secondary
  secondaryLight: '#e0f2f1',
  secondaryMain: '#009688',
  secondaryDark: '#00897b',
  secondary200: '#80cbc4',
  secondary800: '#00695c',

  // success
  successLight: '#edf7ed',
  success200: '#b6e0b3',
  successMain: '#6cc067',
  successDark: '#64ba5f',

  // error
  errorLight: '#e48784',
  errorMain: '#d9534f',
  errorDark: '#d54c48',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fdf5ea',
  warningMain: '#f0ad4e',
  warningDark: '#ec9c3d',

  // grey
  grey50: '#f8fafc',
  grey100: '#eef2f6',
  grey200: '#e3e8ef',
  grey300: '#cdd5df',
  grey500: '#697586',
  grey600: '#4b5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkBackground: '#0e1b23', // level 3
  darkPaper: '#060d12', // level 4

  // dark levels
  darkLevel1: '#0b161d',
  darkLevel2: '#14252f',

  // primary dark
  darkPrimaryLight: '#eceff1',
  darkPrimaryMain: '#78919c',
  darkPrimaryDark: '#587583',
  darkPrimary200: '#b0bec5',
  darkPrimary800: '#44606e',

  // secondary dark
  darkSecondaryLight: '#e0f2f1',
  darkSecondaryMain: '#009688',
  darkSecondaryDark: '#00897b',
  darkSecondary200: '#80cbc4',
  darkSecondary800: '#00695c',

  // text variants
  darkTextTitle: '#e4e8f7',
  darkTextPrimary: '#d5d9e9',
  darkTextSecondary: '#d8ddf0'
};

export default theme1;
